import { Center } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { rem } from 'polished';

export const AnimationSurround = styled(Center)`
  font-size: ${rem('16px')};
  display: block;
  text-align: center;
`;
